"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const END_SLASH_REGEX = /\/$/;
function ensureEndSlash(p) {
    return END_SLASH_REGEX.exec(p) ? p : `${p}/`;
}
exports.default = ensureEndSlash;
